import { useState, useEffect } from 'react';
import { SchoolSegment } from '../types/project.types';
import { projectService } from '../services/project.service';

/**
 * Loads the school segments (campuses) for a project. Returns an empty array
 * for single-school projects or while no project is selected. Used by lead
 * capture, the leads list, and scheduling to scope things by campus.
 */
export function useProjectSegments(projectId?: string | null): {
  segments: SchoolSegment[];
  loading: boolean;
} {
  const [segments, setSegments] = useState<SchoolSegment[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;
    if (!projectId) {
      setSegments([]);
      return;
    }
    setLoading(true);
    projectService
      .getProject(projectId)
      .then(p => { if (active) setSegments(p?.schoolSegments || []); })
      .catch(() => { if (active) setSegments([]); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [projectId]);

  return { segments, loading };
}
